import objectAssign from 'object-assign';
import initialState from './initialState';
import { RECEIVE_MERCHANT_DATA } from '../actions/actionTypes';

export default function merchantData(state = initialState.merchantData, action) {
  let newState;
  switch (action.type) {
    case RECEIVE_MERCHANT_DATA:
      newState = objectAssign({}, state);
      newState = action.merchantData;
      return newState;
    default:
      return state;
  }
}
